module.exports = __webpack_public_path__ + "img/poster_zh.7404dd80.png";